<script>
    export let images
</script>

<div class="fv-hero">    
    <picture>   
        <source srcset={images.pc} media="(min-width: 641px)" />
        <source srcset={images.mb} media="(min-width: 0px)" >
        <img src={images.pc} alt="">
    </picture>
</div>
<style>

    .fv-hero{
        display: flex;
        width:100%;
        min-width:1280px;
        height:auto;
    }
    .fv-hero picture,.fv-hero img{
        width:100%;
        height:auto;
        object-fit: cover;
    }
    @media screen and (max-width:640px){
        .fv-hero{
            min-width:100%;
            height:387px;
            width:100%;
        }
        .fv-hero picture,.fv-hero img{
            height:387px;
            width:100%;
            object-fit: cover;
        }
    }
</style>